import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardText } from 'react-bootstrap';
import Auth from '../utils/auth';
import { useAuth } from '../utils/AuthContext';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function Login(props) {
  const [formState, setFormState] = useState({ email: '', password: '' });
  const [error, setError] = useState(null);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [resetError, setResetError] = useState(null);
  const [resetSuccess, setResetSuccess] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
const { login } = useAuth();
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch('https://bkf.onrender.com/investors/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formState),
      });

      if (!response.ok) {
        throw new Error('Failed to log in');
      }

      const { token } = await response.json();
      login(token);
      navigate('/');
    } catch (e) {
      console.error(e);
      setError("The provided credentials are incorrect"); 
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleForgotPassword = async (event) => {
    event.preventDefault();
  
    if (!email.trim()) {
      setResetError('Please enter your email address.');
      setResetSuccess(null);
      return;
    }
  
    try {
      const response = await fetch('https://bkf.onrender.com/passwordRoutes', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
  
      if (!response.ok) {
        throw new Error('Failed to send password reset email');
      }
  
      setResetSuccess('Please check your email and follow the instructions');
      setResetError(null);
    } catch (e) {
      setResetError('Could not reset password');
      setResetSuccess(null);
    }
  };

  const CF_BASE = "https://d2b3xd88n081z3.cloudfront.net";

  return (
    <div 
    >
        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            style={{
                              position: 'fixed',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              zIndex: -1,
                            }}
                              >
                                <source src={`${CF_BASE}/public/backgroundgrey2.mp4`} />
                                Your browser does not support the video tag.
                              </video>
      <form onSubmit={handleFormSubmit}>
        <Card className='card-body container col-10 col-md-6 justify-content-center'
          style={{
            overflow: 'hidden',
            boxSizing: 'border-box',
            // marginTop: '50%',
            width: '420px', maxWidth: '90vw', 
            // marginBottom: '50%',
            position: 'relative',
            color: 'silver',
            borderRadius: '10px'
          }}
        >
          <h1 className="justify-content-center password-heading1"
            style={{
              marginBottom: '1%',
              
              
            }}
          > Investor Login</h1>

          <div className="container justify-content-center row"
            style={{
              display: 'block', 
              flexWrap: 'wrap', 
              gap: '5%',
              
            }}
          >
            {forgotPassword ? (
              // Reset password form
              <div className="forgot-password-section col-12 justify-content-center"
              style={{
                display: 'block', 
                flexWrap: 'wrap', 
                gap: '5%',
                margin:'2%'}}
              >
                 {resetSuccess ? (
              <CardText>
                {resetSuccess}
              </CardText>
              
            ) : (
              <>
                <div className="flex col-12">
                <h2>Email Address</h2>
                <input
                  className='form-control about-card-edit'
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'silver',
                    caretColor: 'grey',
                    width: '100%',
                    maxWidth: '100%',
                    marginBottom: '10px',
                    boxSizing: 'border-box',
                    fontSize: '1.2rem',
                  }}
                />
                </div>

                <div className="col-12 flex-row flex-end">
                <Button 
                  type="button"
                  onClick={handleForgotPassword}
                  className="process-card-text hover-brighten col-12"
                  style={{
                    display: 'block',
                   
                    width: 'auto',
                    margin: '20px auto',
                    fontSize: '2.5vmin',
                    background: 'none',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    textAlign: 'center',
                  }}
                >
                  <h3 style={{ margin: '1%' }}>Reset Password</h3>
                </Button>
                </div>        
                {resetError && 
                <CardText>
                  {resetError}
                </CardText>}
                </>
                )}
              </div>
            ) : (
              // Login form
              <div className='justify-content-center row'
                style={{
                  // display: 'block', 
                  flexWrap: 'wrap', 
                  gap: '5%',
                  margin:'2%'
                }}
              >
                <div className="flex col-12">
                  <label htmlFor="email">
                    <h2>Email Address</h2>
                  </label>
                  <input
                    placeholder=""
                    name="email"
                    type="email"
                    id="email"
                    className="form-control about-card-edit"
                    onChange={handleChange}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: 'silver',
                      caretColor: 'grey',
                      width: '100%',
                      maxWidth: '100%',
                      marginBottom: '10px',
                      boxSizing: 'border-box',
                      fontSize: "clamp(1rem, 1.8vw, 1.5rem)",
                    }}
                  />
                </div>

                {/* <div className="flex col-12">
                  <label htmlFor="pwd">
                    <h2>Password</h2>
                  </label>
                  <input
                    placeholder=""
                    name="password"
                    type={showPassword ? "text" : "password"}
                    id="pwd"
                    className="form-control about-card-edit"
                    onChange={handleChange}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: 'silver',
                      caretColor: 'grey',
                      width: '100%',
                      maxWidth: '100%',
                      marginBottom: '10px',
                      boxSizing: 'border-box',
                      fontSize: '1.2rem',
                    }}
                  />
                  
                </div> */}
<div className="flex col-12">
  <label htmlFor="pwd">
    <h2>Password</h2>
  </label>

  <div style={{ position: 'relative', width: '100%' }}>
    <input
      placeholder=""
      name="password"
      type={showPassword ? "text" : "password"}
      id="pwd"
      className="form-control about-card-edit"
      onChange={handleChange}
      style={{
        background: 'none',
        border: 'none',
        color: 'silver',
        caretColor: 'grey',
        width: '100%',
        paddingRight: '40px', // 👈 space for the icon
        marginBottom: '10px',
        boxSizing: 'border-box',
        fontSize: "clamp(1rem, 1.8vw, 1.5rem)",
      }}
    />

    <button
      type="button"
      onClick={() => setShowPassword(!showPassword)}
      style={{
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: 'silver',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <span className="eye-icon"
       style={{
    fontSize: "clamp(1rem, 1.8vw, 1.5rem)",
    display: "flex",
    alignItems: "center"
  }}
      >
        {showPassword ? <FaEyeSlash /> : <FaEye />}
      </span>
    </button>
  </div>
</div>
                
                {error && (
                  <div>
                    <p className="error-text">{error}</p>
                  </div>
                )}
              </div>
            )}
          </div>

          {!forgotPassword && (
            <div className="flex col-12">
              <Button 
                type="submit" 
                className="process-card-text hover-brighten"
                style={{
                  display: 'block',
                  height: '40%',
                  width: 'auto',
                  margin: '10px auto',
                  fontSize: '2.5vmin',
                  backgroundColor: 'rgb(67, 66, 66)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  textAlign: 'center',
                }}
              >
                <h2 style={{ margin: '1%' }}>Login</h2>
              </Button>
            </div>
          )}
 

          {/* Forgot Password Button */}
          {!forgotPassword && (
            <div className="forgot-password-button d-flex justify-content-center col-12 ">
              <Button className="hover-brighten"
                onClick={() => setForgotPassword(true)}
                style={{ border: 'none', textAlign: 'center', background: 'none', cursor: 'pointer',
                  
                 }}
              >
               <h3>Forgot Password?</h3>
              </Button>
            </div>
          )}
        </Card>
      </form>
    </div>
  );
}

export default Login;
